import React, { useState } from 'react';
import { useRequest } from 'hooks';

import Modal from 'components/Modal';
import { Button, Textarea, Select } from 'components/Misc/Form';

import { useGradeCertificateStore } from 'store/grade/useGradeCertificateStore';

const Edit = ({ award, modal, onModal }) => {
	// Use grade certificate store
	const onChangeAward = useGradeCertificateStore(state => state.onChangeAward);

	// Store request
	const [[progress], request] = useRequest('put', `awards/${award.id}`);

	// Handle award change
	const onChange = change => {
		onChangeAward(award, change);
	};

	// Handle submit event
	const onUpdate = async (event) => {
		event.preventDefault();

		// Try to create award
		const [success] = await request(award);

		// Close modal on success
		if (success) onModal();
	};

	return (
		<Modal title="Labot apbalvojuma datus" visible={modal} handleModal={onModal}>
			<div className="flex flex-col gap-4">
				<Select
					name="type"
					label="Tips"
					placeholder=" "
					value={award.type}
					onChange={onChange}
					options={[
						{ value: 'attendance', name: 'Piedalījās' },
						{ value: 'award', name: 'Apbalvojums' }
					]}
				/>

				<Textarea
					name="for"
					label="Apraksts"
					value={award.for}
					onChange={onChange}
				/>

				<div className="col-span-2 flex justify-end">
					<Button
						icon="check"
						theme="success"
						value="Saglabāt"
						progress={progress}
						onClick={onUpdate}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default Edit;